import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from './guards/auth.guard';
import { HomeComponent } from './login/components/home/home.component';

export const routes: Routes = [
	{ path: '', component: HomeComponent, title: 'Luna Contact Lens Fulfillment Login' },
	{
		path: 'forgotpassword',
		loadComponent: () => import('./login/components/forgotpassword/forgotpassword.component').then(m => m.ForgotPasswordComponent),
		title: "Forgot your password?"
	},
	{
		path: 'privacy',
		loadComponent: () => import('./login/components/privacy/privacy.component').then(m => m.PrivacyComponent)
	},
	{
		path: 'faq',
		loadComponent: () => import('./login/components/faq/faq.component').then(m => m.FaqComponent)
	},
	{
		path: 'toc',
		loadComponent: () => import('./login/components/toc/toc.component').then(m => m.TocComponent)
	},
	{
		path: 'resetpassword',
		loadComponent: () => import('./login/components/resetpassword/resetpassword.component').then(m => m.ResetPasswordComponent),
		title: "Reset your password"
	},
	{
		path: 'redirect',
		loadComponent: () => import('./login/components/redirect/redirect.component').then(m => m.RedirectComponent),
		title: "Processing Authentication"
	},
	{ path: 'admin', redirectTo: 'admin/users', pathMatch: 'full' },
	{
		path: 'admin/users',
		loadComponent: () => import('./portal/pages/useradmin/useradmin.component').then(m => m.UserAdminComponent),
		title: "Users List",
		canActivate: [AuthGuard]
	},
	{
		path: 'admin/user/:id',
		loadComponent: () => import('./portal/pages/useradmin/useradmin.component').then(m => m.UserAdminComponent),
		title: "Edit User",
		canActivate: [AuthGuard]
	},
	{
		path: 'admin/create',
		loadComponent: () => import('./portal/pages/useradmin/useradmin.component').then(m => m.UserAdminComponent),
		title: "Create User",
		canActivate: [AuthGuard]
	},
	{
		path: 'admin/pricing',
		loadComponent: () => import('./portal/pages/pricing/pricing.component').then(m => m.PricingComponent),
		title: "Pricing Management",
		canActivate: [AuthGuard]
	},
	{
		path: 'admin/dashboard/orders',
		loadComponent: () => import('./portal/pages/order-volume/order-volume.component').then(m => m.OrderVolumeComponent),
		title: "Order Volume",
		canActivate: [AuthGuard]
	},
	{
		path: 'admin/avail',
		loadComponent: () => import('./portal/pages/availability/availability.component').then(m => m.AvailabilityComponent),
		title: "Availability Management",
		canActivate: [AuthGuard]
	},
	{
		path: 'styleguide',
		loadComponent: () => import('./portal/pages/styleguide/styleguide.component').then(m => m.StyleguideComponent),
		title: "Style Guide",
		canActivate: [AuthGuard]
	},
	{
		path: 'tools/product-lookup',
		loadComponent: () => import('./portal/pages/tools/upc-lookup/upc-lookup.component').then(m => m.UpcLookupComponent),
		title: "Product Lookup",
		canActivate: [AuthGuard]
	},
	{
		path: 'tools/payload-lookup',
		loadComponent: () => import('./portal/pages/tools/payload-lookup/payload-lookup.component').then(m => m.PayloadLookupComponent),
		title: "Payload Lookup",
		canActivate: [AuthGuard]
	},

	// Wildcard for 404
	{
		path: '**',
		loadComponent: () => import('./components/notfound/notfound.component').then(m => m.NotfoundComponent),
		title: 'Page Not Found'
	}
];
